import { Text } from "@chakra-ui/react";

export function MetaDataText(props) {
    return <Text color="gray.500" fontSize="sm">{props.children}</Text>
}